import { ConfirmationModal as SuiConfirmationModal } from '@hrworks/sui-core'

interface SessionExpiredModalProps {
  onConfirm: () => void
}

export const SessionExpiredModal = ({ onConfirm }: SessionExpiredModalProps) => (
  <SuiConfirmationModal
    show
    title="Session expired"
    confirmText="Sign in again"
    onConfirm={onConfirm}
    isConfirmEnabled
    closeOnBackdropClick={false}
  >
    Your session has expired. Please sign in again to continue.
  </SuiConfirmationModal>
)
